export const API_URL: string =
    process.env.NODE_ENV === "development"
            ? `http://localhost:5001/${process.env.REACT_APP_PROJECT_ID}/europe-west1`
        : `https://europe-west1-${process.env.REACT_APP_PROJECT_ID}.cloudfunctions.net`;
